export default "__VITE_ASSET__FDl4CM0P__"